<template>
  <div class="user-detail-container">
    <fda-header-tab-bar :user-index="currentIndex" :people-lists="peopleList" @tab-change="handleTabChange" />
    <HistoryList ref="historyListRef" :profile-id="profileId" />
  </div>
</template>
<script lang="ts">
export default {
  name: 'FollowUpHistoryList',
};
</script>
<script setup lang="ts">
import { HeaderTabBarProps } from '@/components/header-tab-bar';
import { ResSignList, ISignItem } from '@tencent/fd-types/patient';
import { useUserStore } from '@/store/modules/user';
import { useConfigStore } from '@/store/modules/config';
import { PageTypeEnum } from '@tencent/fd-types';
import HistoryList from './HistoryList.vue';
import { router } from '@/router';

const userStore = useUserStore();
const useConfig = useConfigStore();
const { dict } = toRefs(useConfig);
let userSignList: ResSignList;
const currentIndex = ref(0);
// 定义用户列表
const peopleList = ref<HeaderTabBarProps[] | undefined>([]);

// 定义用户id和关系id
const profileId = ref<string | undefined>('');
const relation = ref<number | undefined>(0);

const queryPeopleList = async () => {
  userSignList = await userStore.signList({ pageType: PageTypeEnum.record });
  console.log('userSignList', userSignList);
  currentIndex.value =
    userSignList?.signItem?.findIndex((item) => item.userMsg.profileId === router.currentRoute.value.query.userId) ??
    0;
  userSignList?.signItem?.[0];
  console.log('currentIndex', currentIndex);
  profileId.value = userSignList?.signItem?.[currentIndex.value]?.userMsg?.profileId;
  relation.value = userSignList?.signItem?.[currentIndex.value]?.userMsg?.relation;

  peopleList.value = userSignList.signItem?.map((user) => {
    return {
      profileId: user?.userMsg?.profileId,
      photo: user?.userMsg?.photo,
      fullNameMask: user?.userMsg?.fullNameMask,
      age: user?.userMsg?.age,
      relation: user?.userMsg?.relation ? dict.value?.userRelation[user?.userMsg?.relation] : '',
      gender: user?.userMsg?.gender ? dict.value?.gender[user?.userMsg?.gender] : '',
    };
  });
};
const handleTabChange = (Id) => {
  currentIndex.value =
    userSignList?.signItem?.findIndex((user) => {
      return user.userMsg.profileId === Id;
    }) ?? 0;
  profileId.value = userSignList?.signItem?.[currentIndex.value]?.userMsg?.profileId;
  relation.value = userSignList?.signItem?.[currentIndex.value]?.userMsg?.relation;
};
const historyListRef = ref();
const setUp = () => {
  queryPeopleList().then(() => {
    historyListRef.value.getFollowUpHistoryPlanList(profileId.value);
  });
};
onActivated(async () => {
  setUp();
});
</script>

<style scoped lang="less">
.user-detail-container {
  position: relative;
  margin: 0;
  padding: 0;

  .history-btn {
    padding: 16px 24px;
    text-align: right;
    font-size: 28px;
    color: #848e99;
  }
}
</style>
